export default __webpack_public_path__ + "videos/b1c49910bb1126fbd0515c3c2dbfd8cb.mp4";